import { render, staticRenderFns } from "./EditMyComments.vue?vue&type=template&id=745c3c86&scoped=true&"
import script from "./EditMyComments.vue?vue&type=script&lang=js&"
export * from "./EditMyComments.vue?vue&type=script&lang=js&"
import style0 from "./EditMyComments.vue?vue&type=style&index=0&id=745c3c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c3c86",
  null
  
)

export default component.exports